<div>Your subscription will end on {{ subscription.current_period_end.seconds * 1000 | date }}</div>
